<template>
  <base-image :src="url" :alt="result.title" :height="height" :width="width" loading="lazy" />
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseImage from 'vuecomponents/base_image'
import { proxiedUrl, processedUrl } from '@padlet/vivaldi-client'

export default {
  components: { BaseImage },
  props: {
    result: Object,
    width: Number,
    aspectRatio: Number,
  },
  computed: {
    url() {
      if (this.result.thumbnail_width && this.result.thumbnail_width > 500) {
        const processingOptions = { width: this.width, crop: 'thumb' }
        if (this.aspectRatio) {
          processingOptions.ar = this.aspectRatio
        }
        return processedUrl(this.result.thumbnail_url, processingOptions)
      }
      return proxiedUrl(this.result.thumbnail_url)
    },
    height() {
      const aspectRatio = this.aspectRatio
        ? this.aspectRatio
        : this.result.thumbnail_width / this.result.thumbnail_height
      return Math.floor(this.width / aspectRatio)
    },
  },
}
</script>
